var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"app-wrapper",class:_vm.classObj},[_c('div',{staticClass:"main-container"},[_c('navbar'),_vm._v(" "),_c('app-main'),_vm._v(" "),(_vm.device=='desktop')?_c('sidebar',{staticClass:"sidebar-container"}):_vm._e(),_vm._v(" "),(_vm.device=='mobile')?_c('bottom-sidebar',{staticClass:"bottom-sidebar-container"}):_vm._e()],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2daf478b","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/layout/Layout.vue
// module id = null
// module chunks = 